// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Axios Imports
import axios, { AxiosError } from "axios";

export const getAllCustomers = createAsyncThunk(
  "customers/getAllData",
  async ({}, { getState }) => {
    let bodyContent = {
      params: {
        query: {
          building: getState()?.CurrentBuilding
            ? [getState()?.CurrentBuilding?.data?._id]
            : undefined,
        },
        options: {
          populate: [
            {
              path: "createdBy",
              dir: "users",
              select: "_id username",
            },
          ],
        },
      },
    };
    const response = await axios.get("/customers", bodyContent);
    if (response.status != 200) {
      return rejectWithValue(response.data.message);
    }
    const docs = response.data?.data?.docs || [];
    return { docs, totalRows: response.data?.data?.totalDocs };
  }
);

export const getData = createAsyncThunk(
  "customers/getData",
  async (params, { getState }) => {
    const response = await axios.get("/customers", {
      params: {
        query: {
          building: getState()?.CurrentBuilding
            ? [getState()?.CurrentBuilding?.data?._id]
            : undefined,
        },
        options: {
          ...params,
          populate: [
            {
              path: "createdBy",
              dir: "users",
              select: "_id username",
            },
          ],
        },
      },
    });
    if (response.status != 200) {
      return rejectWithValue(response.data.message);
    }
    return {
      params,
      data: response.data?.data?.docs,
    };
  }
);

export const getCustomerDetail = createAsyncThunk(
  "customers/getCustomerDetail",
  async (id) => {
    const response = await axios.get(`/customers/detail/${id}`);
    if (response.status != 200) {
      return rejectWithValue(response.data.message);
    }
    return response?.data;
  }
);

export const createCustomer = createAsyncThunk(
  "customers/create",
  async (
    formdata,
    { dispatch, getState, rejectWithValue, fulfillWithValue }
  ) => {
    try {
      dispatch(isLoading(true));
      var response = await axios.post("/customers", {
        ...formdata,
        building: getState()?.CurrentBuilding?.data?._id ?? undefined,
      });

      // dispatch(addCustomer(response.data?.data));
      if (response.status != 200) {
        return rejectWithValue(response.data.message);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
    dispatch(isLoading(false));
  }
);

export const updateCustomer = createAsyncThunk(
  "customers/update",
  async ({ data, id }, { dispatch, getState, rejectWithValue }) => {
    try {
      console.log(data);
      var response = await axios.patch(`/customers/${id}`, data);
      // await dispatch(getData(getState().users.params));

      if (response.status != 200) {
        return rejectWithValue(response.data.message);
      }

      //  dispatch(editCustomer(response.data?.data));

      return response.data?.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        var { response } = error;
        return rejectWithValue(response.data.message);
      }
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  "customers/delete",
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      const response = await axios.delete(`/customers/${id}`);
      console.log(response.data);
      if (response.status != 204) {
        return rejectWithValue("Can't Delete Try Again");
      }
      await dispatch(getAllCustomers());
      return response.status;
    } catch (error) {
      if (error instanceof AxiosError) {
        var { response } = error;
        return rejectWithValue(response.data.message);
      }
    }
  }
);

export const getCustomerStatement = createAsyncThunk(
  "customers/getCustomerStatement",
  async ({ id, start, end }, { dispatch, getState, rejectWithValue }) => {
    try {
      const response = await axios.get(`/customers/statement/${id}`, {
        params: { start, end },
      });
      // if (response.status != 204) {
      //   return rejectWithValue("No Record Found");
      // }

      return response.data?.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        var { response } = error;
        return rejectWithValue(response.data.message);
      }
    }
  }
);

export const customerSlice = createSlice({
  name: "customers",
  initialState: {
    data: [],
    total: 0,
    params: {},
    allData: [],
    loading: false,
    error: null,
    selectedCustomer: null,
    customerDetail: {
      loading: false,
      data: {},
    },
  },
  reducers: {
    isLoading: (state, { payload }) => {
      state.loading = payload;
      state.error = null;
    },
    addCustomer: (state, { payload }) => {
      state.allData.push(payload);
      state.data.push(payload);
    },
    selectCustomer: (state, { payload }) => {
      state.selectedCustomer = payload;
    },
    editCustomer: (state, { payload }) => {
      state.data = state.data.map((d) => {
        if (d._id == payload._id) {
          return payload;
        }
        return d;
      });
      state.allData = state.allData.map((da) => {
        if (da._id == payload._id) {
          return payload;
        }
        return da;
      });
      state.loading = false;
      state.error = null;
      state.selectedCustomer = null;
    },
    searchFilter: (state, { payload }) => {
      if (payload == "") {
        state.data = state.allData;
        return;
      }

      state.data = state.allData.filter(
        (cs) =>
          cs.name?.toLowerCase().includes(payload.toLowerCase()) ||
          cs.phone?.toLowerCase().includes(payload.toLowerCase()) ||
          cs.email?.toLowerCase().includes(payload.toLowerCase())
      );
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomers.pending, (state, action) => {
        state.loading = !state.data.length ? true : false;
        state.error = null;
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        state.data = action.payload.docs;
        state.allData = action.payload.docs;
        state.total = action.payload.totalRows;
        state.loading = false;
        state.error = null;
      })
      .addCase(getAllCustomers.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getData.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.params = action.payload.params;
        state.loading = false;
      })
      .addCase(getData.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = error;
      })
      // .addCase(createCustomer.pending, (state, { payload }) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      .addCase(createCustomer.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.error = null;
        state.selectedCustomer = null;
        state.allData.unshift(payload.data);
        state.data.unshift(payload.data);
      })
      // .addCase(createCustomer.rejected, (state, { payload, error }) => {
      //   state.loading = false;
      //   state.error = payload;
      //   state.selectedCustomer = null;
      // })

      .addCase(updateCustomer.pending, (state, { payload }) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCustomer.fulfilled, (state, { payload }) => {
        console.log(payload);
        state.loading = false;
        state.error = null;
        state.data = state.data.map((d) => {
          if (d._id == payload._id) {
            return payload;
          }
          return d;
        });
        state.allData = state.allData.map((da) => {
          if (da._id == payload._id) {
            return payload;
          }
          return da;
        });
        state.selectedCustomer = null;
      })
      .addCase(updateCustomer.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = error;
      })
      .addCase(getCustomerDetail.pending, (state, { payload, error }) => {
        state.customerDetail.loading = true;
      })
      .addCase(getCustomerDetail.fulfilled, (state, { payload, error }) => {
        state.customerDetail.loading = false;
        state.customerDetail = { ...payload };
      })
      .addCase(getCustomerDetail.rejected, (state, { payload, error }) => {
        state.customerDetail.loading = false;
        state.customerDetail = {};
      })
      .addCase(getCustomerStatement.fulfilled, (state, { payload, error }) => {
        state.customerDetail.loading = false;

        state.customerDetail = {
          ...state.customerDetail,
          data: { ...state.customerDetail.data, statement: payload },
        };
      });
  },
});

export const { selectCustomer, searchFilter, isLoading } =
  customerSlice.actions;
export default customerSlice.reducer;
